import React, { useState, useMemo, useEffect, useLayoutEffect, useCallback } from 'react';
import '../style.css';
import { useSelector, useDispatch } from 'react-redux';
import Avatar from '@mui/material/Avatar';
import { toast, ToastContainer } from 'react-toastify';
import { ReactComponent as Close } from '../../../assets/images/teamclose.svg';
import { ReactComponent as TeamInfo } from '../../../assets/images/teaminfo.svg';
import { ReactComponent as TeamChat } from '../../../assets/images/teamchat.svg';
import { ReactComponent as TeamGroups } from '../../../assets/images/teamgroup.svg';
import { ReactComponent as TeamTicket } from '../../../assets/images/teamticket.svg';
import { ReactComponent as TeamWorking } from '../../../assets/images/teamworking.svg';
import { ReactComponent as AccountTypeIcon } from '../../../assets/images/accountlogo.svg';
import { ReactComponent as AccountChat } from '../../../assets/images/accountchat.svg';
import { ReactComponent as AccountLogin } from '../../../assets/images/accountlogin.svg';
import { ReactComponent as AccountSeen } from '../../../assets/images/accountseen.svg';
import { ReactComponent as ActiveInfo } from '../../../assets/images/activeinfo.svg';
import { ReactComponent as ActiveChat } from '../../../assets/images/activechat.svg';
import { ReactComponent as ActiveGroup } from '../../../assets/images/activegroup.svg';
import { ReactComponent as ActiveTicket } from '../../../assets/images/activeticket.svg';
import { ReactComponent as ActiveWorking } from '../../../assets/images/activeworking.svg';
import Supervisor from '../Supervisor';
import TeamAssignChat from '../TeamAssignChat';
import TeamGroup from './TeamGroup';
import TicketSection from '../TeamTicket';
import TeamWorkingSection from '../TeamWorking';
import { ListUserIndApi } from '../../../store/features/listCoUserIndividual';
import Loader from '../../../../src/assets/Loader';
import { useNavigate } from 'react-router-dom';
import { ListAllRoomsApi } from '../../../store/features/ListAllRooms';
import { Skeleton } from '@mui/material';
import {
  getProfileWarmEntry,
  mergeProfileSettingsWarmCache,
} from '../../../utils/profileSettingsWarmCache';

const TeamSideBarSection = [0, 1, 2, 3, 4];

function mapUserIndPayloadToSidebar(item) {
  if (!item) return { dataRows: [], groupUsers: [] };
  const userGroups = (item.groups ?? []).map((user) => user);
  const row = {
    id: item?.id || item?._id,
    img: item?.agent_image,
    name: item?.full_name,
    email: item?.email,
    group: 'hello',
    role: item?.role_name,
    acceptChat: item?.accept_chat,
    offline: item?.is_offline,
    chat_limit: item?.agent_chat_limit,
  };
  return { dataRows: [row], groupUsers: userGroups };
}

function hasWarmProfileForUserId(userId) {
  if (!userId) return false;
  const e = getProfileWarmEntry(userId);
  return !!(e?.hasFetchedProfile && e?.userPayload);
}

function TeamSideBar(props) {
  const { userList = [], onOpen, onCancel, onViewAllGroups } = props;
  const [isLoading, setIsLoading] = useState(
    () => !hasWarmProfileForUserId(userList?.id)
  );
  const [activeItem, setActiveItem] = useState(0);
  const [dataItem, setDataItem] = useState([]);
  const [groupUser, setGroupUser] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [selectedState, setSelectedState] = useState(TeamSideBarSection[0]);
  const [isRoomsLoading, setIsRoomsLoading] = useState(false);
  const authToken = useSelector((state) => state.loginToken);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );
  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );

  const getUserlList = useCallback(
    async (options = {}) => {
      const { background = false } = options;
      if (!userList?.id) return;
      if (!background) {
        setIsLoading(true);
      }
      try {
        const data = await dispatch(
          ListUserIndApi({
            id: userList.id,
            authToken: authToken?.response?.token,
          }),
        );
        if (typeof data.payload === 'undefined') {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.status === 200) {
          const item = data?.payload?.data;
          mergeProfileSettingsWarmCache({
            userId: userList.id,
            userPayload: item,
            hasFetchedProfile: true,
          });
          const { dataRows, groupUsers } = mapUserIndPayloadToSidebar(item);
          setDataItem(dataRows);
          setGroupUser(groupUsers);
        } else if (data?.payload?.status === 500) {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.status === 401) {
          toast.error('Login Expired. Please login  and try again.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
          navigate('/login');
        }
      } catch (error) {
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      } finally {
        if (!background) {
          setIsLoading(false);
        }
      }
    },
    [userList?.id, authToken?.response?.token, dispatch, navigate],
  );

  useLayoutEffect(() => {
    if (!userList?.id) return;
    const e = getProfileWarmEntry(userList.id);
    const same = !!(e?.hasFetchedProfile && e?.userPayload);
    if (same) {
      const { dataRows, groupUsers } = mapUserIndPayloadToSidebar(e.userPayload);
      setDataItem(dataRows);
      setGroupUser(groupUsers);
      setIsLoading(false);
      getUserlList({ background: true });
    } else {
      setDataItem([]);
      setGroupUser([]);
      setIsLoading(true);
      getUserlList({ background: false });
    }
  }, [userList?.id, getUserlList]);

  const chracterPosition = (alphabet) => {
    const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const positionOfAlphabet = alphabets.indexOf(alphabet) + 1;
    return positionOfAlphabet;
  };

  const colorCodesForAvatar = [
    '#405261', '#FF4D4F', '#FA541C', '#FA8C16', '#FAAD14', '#EB2F96',
    '#FADB14', '#A0D911', '#52C41A', '#5CDBD3', '#9254DE', '#F759AB',
    '#2F54EB', '#722ED1', '#1890FF', '#13C2C2', '#2DB7F5', '#19BE6B',
    '#30A745', '#FA8C16', '#FAAD14', '#9254DE', '#F759AB', '#13C2C2',
    '#722ED1', '#2DB7F5',
  ];

  useEffect(() => {
    let mounted = true;

    const getRooms = async () => {
      if (mounted && userList?.id && authToken?.response?.user?.business_id) {
        setIsRoomsLoading(true);
        try {
          const response = await dispatch(
            ListAllRoomsApi({
              mainUserId: userList.id,
              business_id: authToken.response.user.business_id
            })
          );

          if (mounted) {
            if (response?.payload?.rooms) {
              setRooms(response?.payload?.rooms.filter(room =>
                room?.is_unAssigned === false && room?.is_archived === false
              ));
            } else {
              setRooms([]);
            }
          }
        } catch (error) {
          console.error('Error fetching rooms:', error);
          if (mounted) {
            setRooms([]);
          }
        } finally {
          if (mounted) {
            setIsRoomsLoading(false);
          }
        }
      }
    };

    getRooms();

    return () => {
      mounted = false;
    };
  }, [userList?.id, authToken?.response?.user?.business_id, dispatch]);

  // Handler to refresh group list

  // Handler for editing a group
  const handleEditGroup = (groupId) => {
    navigate(`/groupupdate/${groupId}`);
  };

  const registrationUIRender = useMemo(
    () => (
      <>
        {selectedState === 0 ? (
          dataItem?.map((item, index) => (
            <div key={index}>
              <div className="AccountType-Main-Container">
                <div className="AccountType-content">
                  <div className="Account-Type01">
                    <AccountTypeIcon />
                    <p className="AccountType-text">{t.ACCOUNT_TYPE}</p>
                  </div>
                  <p className="AccountAgent-text">{item?.role.charAt(0).toUpperCase() + item.role.slice(1)}</p>
                </div>
                <div className="AccountType-content">
                  <div className="Account-Type01">
                    <AccountChat />
                    <p className="AccountType-text">{t.CHATLIMIT}</p>
                  </div>
                  <p className="AccountAgent-text">{item?.chat_limit} Concurrent Chats</p>
                </div>
                <div className="AccountType-content">
                  <div className="Account-Type01">
                    <AccountLogin />
                    <p className="AccountType-text">{t.LOGINSTATUS}</p>
                  </div>
                  <p className="AccountAgent-text">
                    {!item.acceptChat && item.offline
                      ? 'Offline'
                      : !item.acceptChat
                        ? 'Not Accepting Chat'
                        : 'Accepting Chat'}
                  </p>
                </div>
                <div className="AccountType-content">
                  <div className="Account-Type01">
                    <AccountSeen />
                    <p className="AccountType-text">{t.LASTSEEN}</p>
                  </div>
                  <p className="AccountAgent-text">{t.JUSTNOW}</p>
                </div>
              </div>
              <div className="TeamAssign-Container">
                <TeamAssignChat rooms={rooms} userId={userList.id} isLoading={isRoomsLoading} />
              </div>
            </div>
          ))
        ) : selectedState === 1 ? (
          <div className="TeamAssign-Container">
            <TeamAssignChat rooms={rooms} userId={userList.id} isLoading={isRoomsLoading} />
          </div>
        ) : selectedState === 2 ? (
          <div className="TeamGroup-Container">
            <TeamGroup
              groupUser={groupUser}
              onViewAllGroups={onViewAllGroups}

              onEditGroup={handleEditGroup}
            />
          </div>
        ) : selectedState === 3 ? (
          <div className="TeamGroup-Container">
            <TicketSection />
          </div>
        ) : selectedState === 4 ? (
          <div className="TeamGroup-Container">
            <TeamWorkingSection userId={userList.id} />
          </div>
        ) : null}
      </>
    ),
    [selectedState, dataItem, rooms, isRoomsLoading, userList?.id, t, onViewAllGroups, groupUser]
  );

  const handleItemClick = (index) => {
    setActiveItem(index);
    setSelectedState(index);
  };

  const data = [
    {
      id: 0,
      title: 'Info',
      logo: <TeamInfo />,
      ActiveLogo: <ActiveInfo />,
    },
    {
      id: 1,
      title: 'Chats',
      logo: <TeamChat />,
      ActiveLogo: <ActiveChat />,
    },
    {
      id: 2,
      title: 'Groups',
      logo: <TeamGroups />,
      ActiveLogo: <ActiveGroup />,
    },
    {
      id: 3,
      title: 'Tickets',
      logo: <TeamTicket />,
      ActiveLogo: <ActiveTicket />,
    },
    {
      id: 4,
      title: 'Working Hours',
      logo: <TeamWorking />,
      ActiveLogo: <ActiveWorking />,
    },
  ];

  return (
    <>
      <div
        className={`Team-Main-SideBar ${onOpen
          ? 'Team-Main-SideBar--open'
          : 'Team-Main-SideBar--closed'
          }`}
      >
        {isLoading ? (
          <div style={{ padding: '16px' }}>
            {/* Header skeleton */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Skeleton variant="text" width={80} height={28} />
              <Skeleton variant="circular" width={24} height={24} />
            </div>

            {/* Profile avatar and name */}
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px', gap: '12px' }}>
              <Skeleton variant="circular" width={56} height={56} />
              <div style={{ flex: 1 }}>
                <Skeleton variant="text" width="60%" height={20} />
                <Skeleton variant="text" width="80%" height={18} />
              </div>
            </div>

            {/* Role button */}
            <Skeleton
              variant="rounded"
              height={30}
              width={120}
              sx={{ borderRadius: '16px', marginTop: '16px' }}
            />

            {/* Divider line */}
            <Skeleton variant="rectangular" height={1} sx={{ my: 2, bgcolor: '#E5EAF0' }} />

            {/* Sidebar tabs skeleton */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '8px' }}>
              {Array.from({ length: 5 }).map((_, idx) => (
                <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <Skeleton variant="circular" width={32} height={32} />
                  <Skeleton variant="text" width={100} height={18} />
                </div>
              ))}
            </div>

            {/* Content section skeleton */}
            <div style={{ marginTop: '20px' }}>
              <Skeleton variant="rounded" height={120} sx={{ borderRadius: '8px' }} />
            </div>
          </div>
        ) : (
          <>
            <div className="Team-SideBar">
              <p className="detail-text">{t.Details}</p>
              <p className="TeamClose-btn" onClick={onCancel}>
                <Close />
              </p>
            </div>
            <div className="Team-sidebar-profile">
              {dataItem?.map((user, index) => (
                <React.Fragment key={index}>
                  <div className="Team-logo-profile">
                    {user.img ? (
                      <p>
                        <Avatar
                          src={user.img}
                          alt="User Logo"
                          style={{ width: '56px', height: '56px', borderRadius: '32px' }}
                        />
                      </p>
                    ) : (
                      <p>
                        <Avatar
                          sx={{
                            bgcolor:
                              colorCodesForAvatar[
                              chracterPosition(user?.name?.substring(0, 1).toUpperCase())
                              ],
                          }}
                        >
                          {user?.name?.substring(0, 1).toUpperCase()}
                        </Avatar>
                      </p>
                    )}
                    <div className="team-profile-text">
                      <p className="Robert-Fox">{user.name}</p>
                      <p className="Nathan-Fox">{user.email}</p>
                    </div>
                  </div>
                  <button style={{ cursor: 'default' }} className="agent-button" type="button">
                    {user.role.charAt(0).toUpperCase() + user.role.slice(1)}
                  </button>
                </React.Fragment>
              ))}
            </div>
            <p className="profile-linestyle" />
            <div className="team-profile-header">
              {data.map((item) => (
                <div
                  key={item.id}
                  className={`team-profile-list ${item.id === activeItem ? 'ProfileActive' : ''
                    }`}
                  onClick={() => handleItemClick(item.id)}
                >
                  {item.id === activeItem ? (
                    <p>{item.ActiveLogo}</p>
                  ) : (
                    <p>{item.logo}</p>
                  )}
                  <p className="profile-header-text">{item.title}</p>
                </div>
              ))}
            </div>
            <div className="SideBar-Content-Container">{registrationUIRender}</div>
          </>
        )}
      </div>
    </>
  );
}

export default TeamSideBar;